module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.aa9c7490c2fd52cb96c7.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/glyphicons-halflings-regular.ttf
// module id = 1957
// module chunks = 2